import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

const PrivateRoute = (props) => {
  const {
    component: Component,
    session: {
      isAuthenticated = false,
      role,
    },
    role: routeRole,
    key = 'key',
    ...ownProps
  } = props;

  let render;
  if (!isAuthenticated || (routeRole !== undefined && role !== routeRole)) {
    render = () => (<Redirect to="/login" />);
  } else {
    render = (props) => (<Component key={key} {...props} />);
  }

  return (
    <Route {...ownProps} render={render} />
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
});

export default withRouter(connect(
  mapStateToProps,
  null,
)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/components/session/PrivateRoute.js